/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

/**
 * @param {String} mobile
 * @returns {Boolean}
 */
export function validateMobile(mobile) {
  return /^1[3|4|5|6|7|8|9]\d{9}$/.test(mobile)
}

export function isLettersAndNumbers(str) {
  return /^[A-Za-z0-9]+$/.test(str)
}

// 身份证校验
export function validateIdCard(id) {
  // 1 "验证通过!", 0 //校验不通过 // id为身份证号码
  const format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/
  // 号码规则校验
  if (!format.test(id)) {
    return false
  }
  // 区位码校验
  // 出生年月日校验  前正则限制起始年份为1900;
  const year = id.substr(6, 4) // 身份证年
  const month = id.substr(10, 2) // 身份证月
  const date = id.substr(12, 2) // 身份证日
  const time = Date.parse(month + '-' + date + '-' + year) // 身份证日期时间戳date
  const now_time = Date.parse(new Date()) // 当前时间戳
  const dates = new Date(year, month, 0).getDate() // 身份证当月天数
  if (time > now_time || date > dates) {
    return false
  }
  // 校验码判断
  var c = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2] // 系数
  var b = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'] // 校验码对照表
  var id_array = id.split('')
  var sum = 0
  for (var k = 0; k < 17; k++) {
    sum += parseInt(id_array[k]) * parseInt(c[k])
  }
  if (id_array[17].toUpperCase() !== b[sum % 11].toUpperCase()) {
    return false
  }
  return true
}

// 判断统一信用编码
export const validateCreditCode = val => {
  return /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g.test(val)
}

/**
 * @param {String} mobile
 * @returns {Boolean}
 */
export function isImage(name) {
  return /\.(png|jpg|gif|jpeg|webp)$/i.test(name)
}

/**
 * @param {number} number
 * @returns {Boolean}
 */
export function validNumber(number) {
  const MAX_LONG_INTEGER = 9223372036854775807
  return Number(number) <= MAX_LONG_INTEGER
}
